<template>
  <div :class="'myticketi' ? 'd-none':''" class="ad-container">
    <img v-if="project == 'ticketak'" src="@/assets/img/app_logo_single.png" class="img-fluid" />
    <img v-else src="@/assets/img/102-x-150.jpg" class="img-fluid" />
  </div>
</template>
<script>
import { PROJECT } from "@/helper/constant.js";

export default {
  name: "Advertise",
  data() {
    return {
      project: PROJECT
    };
  }
};
</script>



// WEBPACK FOOTER //
// src/components/partials/advertise.vue